// Notifications plugin
import Notifications from './components/NotificationPlugin'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'

// asset imports
// Pas 1.1 repair: no `import 'jquery'` — nothing in src uses $/jQuery
// and Bootstrap 5 does not need it; the side-effect import only added
// ~30 KB gzip to every initial load.
import 'bootstrap/dist/css/bootstrap.css'
import '/src/assets/sass/light-bootstrap-dashboard.scss'
// NOTE: demo.css is legacy Creative Tim demo styles — still imported but largely unused;
// kept to avoid breaking light-bootstrap-dashboard.scss dependencies. Consider removing
// if no demo-specific classes are referenced in templates.
import '/src/assets/css/demo.css'

// import jquery from 'jquery'

/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
export default {
  install(app) {
    app.use(GlobalComponents)
    app.use(Notifications)
    app.use(GlobalDirectives)
  }
}